exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".anchor-wrapper[data-v-5835f9f8]{height:100px}", ""]);

// exports
